import { useRef } from 'react';
import styles from './SelectQuestion.module.css';

// SelectQuestion component for 'select' type question
export default function SelectQuestion({ data, handleAnswerChange, questionMap, answers, isMarked }) {
  const selectId = data.id;
  const subQuestions = Object.values(questionMap).filter(q => q.pid === selectId);

  const inputRefs = useRef({});

  const handleOptionChange = (id, event) => {
    const isChecked = event.target.checked;

    if (subQuestions.find(subQ => subQ.id === id && subQ.type === 'input')) {
      const inputVal = inputRefs.current[id].value;
      handleAnswerChange(id, isChecked ? inputVal : undefined);
    } else {
      handleAnswerChange(id, isChecked);
    }

    // Doubled logic, already checked and handled in each handleAnswerChange
    // const amountChecked = subQuestions.filter(subQ => {
    //   if (subQ.type === "yesno") return answers[subQ.id]
    //   else return answers[subQ.id] !== undefined;
    // }).length;
    // const enoughChecked = amountChecked >= data.min;
    // handleAnswerChange(selectId, enoughChecked);
  };

  const handleInputChange = (id, event) => {
    const inputValue = event.target.value;
    if (answers[id]) {
      handleAnswerChange(id, inputValue);
    }
  };

  return (
    <div className={isMarked ? styles.marked : ''}>
      <label className={styles.selectQuestion}>{data.question}</label>
      <div className={styles.selectWrapper}>
        {subQuestions.map(subQuestion => (
          <div key={subQuestion.id}>
            <input className={styles.selectCheckbox} type="checkbox" checked={answers[subQuestion.id] || false} onChange={(event) => handleOptionChange(subQuestion.id, event)} />
            {subQuestion.type === "input" ?
              <input
                ref={(el) => { inputRefs.current[subQuestion.id] = el; }}
                className={styles.selectInput}
                type="text"
                placeholder={subQuestion.question}
                defaultValue={answers[subQuestion.id] || ""}
                onChange={(event) => handleInputChange(subQuestion.id, event)}
              /> :
              <label className={styles.selectLabel}>{subQuestion.question}</label>
            }
          </div>
        ))}
      </div>
    </div>
  );
}
